<template>
    <div>

        <skoly-menu
                @updateProfil="emitUpdateProfil"
                :profil="profil"
        />

        <!-- Main -->
        <main v-if="profil.pouzivatel_id" class="profileDashboard position-relative pt-0">
            <img src="assets/img/ulohy-bg.jpg" class="img-fluid position-absolute center-image" alt="" style="z-index:1">
            <div class="container pt-30 position-relative" style="z-index:10">
                <div class="row" style="margin-bottom: 140px;">

                    <!-- Úlohy -->
                    <div class="col-xs-12 col-md-12 col-lg-12 col-xl-4 offset-xl-2">
                        <div class="m-skolskaKarta mb-30 pt-25 pb-25">
                            <h5 class="a-skolskaKarta__title">počet bodov</h5>
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="a-skolskaKarta__value text-success">
                                    <template v-if="profil.pouzivatel_id.pouzivatel_body">{{ profil.pouzivatel_id.pouzivatel_body }}</template>
                                    <template v-else>0</template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-12 col-lg-12 col-xl-4">
                        <div class="m-skolskaKarta mb-30 pt-25 pb-25">
                            <h5 class="a-skolskaKarta__title">vyplnené úlohy</h5>
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="a-skolskaKarta__value text-danger">{{ uspesnost }}</div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="ulohy" v-if="skolskeUlohy.length">
                    <skoly-ulohy-row
                        :kvizova-uloha="null"
                        :tvoriva-uloha="null"
                        :mesiac="mapaUloh.mesiace[0]"
                        :label="mapaUloh.labely[0]"
                        :profil="profil"
                    />
                    <skoly-ulohy-row
                        v-for="(n, mesiac) in 10"
                        :key="mesiac"
                        :kvizova-uloha="mapaUloh.kvizove[mesiac]"
                        :tvoriva-uloha="mapaUloh.tvorive[mesiac]"
                        :mesiac="mapaUloh.mesiace[mesiac]"
                        :label="mapaUloh.labely[mesiac]"
                        :profil="profil"
                    />

                </div>

            </div>
        </main>

    </div>
</template>

<script>
import EventService from '@/services/EventService.js'
import SkolyMenu from "@/components/skoly/SkolyMenu.vue";
import SkolyUlohyRow from "@/components/skoly/SkolyUlohyRow.vue";

export default {
    components: {
        SkolyUlohyRow,
        SkolyMenu,
    },
    props: [
        'profil',
    ],
    data() {
        return {
            skolskeUlohy: [],
            uspesnost: 0,
            mapaUloh: {
                tvorive: [],
                kvizove: [],
                mesiace: ['september', 'október', 'november', 'december', 'január', 'február', 'marec', 'apríl', 'máj', 'jún'],
                labely: [
                    'Registrácia do súťaže',
                    'Pani Jeseň maľuje',
                    'Ahoj, kamarátka Kravička',
                    'Šťastné a veselé',
                    'Hlava, ramená, kolená, palce',
                    // 'Biela zima prišla k nám',
                    'Fašiangová veselica',
                    'Tu bývame my',
                    'Vstávaj, príroda',
                    'Ľúbime vás, mamičky',
                    'Veľké finále sa blíži'
                ],
            }
        }
    },
    mounted() {
        this.getSkolskeUlohy()
        this.loadUspesnost()
    },
    methods: {
        // emit
        emitUpdateProfil() {
            this.$emit('updateProfil')
        },

        async getSkolskeUlohy() {
            let { data } = await EventService.getSkolskeUlohy( this.$route.params.rocnik )
            this.skolskeUlohy = data.data

            this.transformujUlohyDoMapy()
        },

        async loadUspesnost() {
            let { data } = await EventService.getUlohyUspesnost();
            this.uspesnost = data.uspesnost
        },

        transformujUlohyDoMapy() {
            this.mapaUloh.tvorive = this.skolskeUlohy.filter( uloha => uloha.typ === 'tvoriva' )
            this.mapaUloh.kvizove = this.skolskeUlohy.filter( uloha => uloha.typ === 'kvizova' )
        },
    }
}
</script>
